<template>
  <div>
    <div class="order-detail" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
      <backlink />
      <Order :item="this.detail" class="order--detail"></Order>

      <div class="order__btns" v-if="this.detail.status == 3">
        <a href="" class="order__btn btn btn--valider" @click.prevent="showModal = 1">
          <span class="btn__text">Je valide la réception</span>
          <img src="/static/img/pictos/valider.svg" class="btn__picto" alt="">
        </a>
        <div href="" class="order__info info">
          <span class="info__total">Total :</span>
          <span class="info__quantity" v-if="this.detail.lines">{{ this.detail.lines.length }}</span>
          <span class="info__quantity-text">produits</span>
        </div>
      </div>

      <div class="product-container">
        <ProductOrder v-for="item in this.detail.lines" :item="item" class="product--in-content" :addable="false"
          :key="item.id"></ProductOrder>
      </div>

    </div>
    <div class="order-detail order-detail--mobile" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
      <OrderHeader :detail="true"></OrderHeader>
      <Order :item="this.detail" class="order--detail"></Order>
      <div class="product-container" v-if="this.detail.status == 3">
        <ProductOrder v-for="item in this.detail.lines" :item="item" class="product--in-content" :addable="true"
          :showQuantity="'shipped'" :key="item.id"></ProductOrder>
      </div>
      <div class="product-container" v-else-if="this.detail.status >= 4">
        <ProductOrder v-for="item in this.detail.lines" :item="item" class="product--in-content" :addable="false"
          :showQuantity="'received'" :key="item.id"></ProductOrder>
      </div>
      <div class="product-container" v-else>
        <ProductOrder v-for="item in this.detail.lines" :item="item" class="product--in-content" :addable="false"
          :showQuantity="'validated'" :key="item.id"></ProductOrder>
      </div>
      <div class="order__btns" v-if="this.detail.status == 3">
        <a href="" class="order__btn btn btn--valider" @click.prevent="showModal = 1">
          <span class="btn__text">Je valide la réception</span>
          <img src="/static/img/pictos/valider.svg" class="btn__picto" alt="">
        </a>
        <div href="" class="order__info info">
          <span class="info__total">Total :</span>
          <span class="info__quantity" v-if="this.detail.lines">{{ this.detail.lines.length }}</span>
          <span class="info__quantity-text">produits</span>
        </div>
      </div>
    </div>

    <OrderModal v-if="showModal == 1" @close="showModal = 0" :id="this.detail.id" :item="this.detail"></OrderModal>
  </div>
</template>

<script>
import ProductOrder from "@/components/Product/ProductOrder";
import OrderHeader from "@/components/Order/OrderHeader";
import Order from "@/components/Order/Order";
import OrderModal from "@/components/Order/OrderModal";

export default {
  name: "OrderDetail",
  data() {
    return {
      showModal: 0,
      detail: {
        id: null,
        label: null,
        price: null,
      }
    }
  },
  components: {
    ProductOrder,
    OrderHeader,
    Order,
    OrderModal
  },
  computed: {
    items: function() {
      let items = this.$store.getters["order/getMyOrders"];
      return items;
    }
  },
  created(){
    this.$store.dispatch('showLoader');
  },
  mounted() {
    const self = this;

    this.$store.dispatch("order/getMyOrders").then(() => {
      this.detail = this.$store.getters["order/getMyItem"](
        this.$route.params.id
      );
      this.$store.dispatch('hideLoader');
    });
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.order-detail {
  width: 86%;
  margin: 0 auto;
  padding: 1px 0 20px;

  &--mobile {
    width: 100%;
    margin: 0;

    .order__btns {
      position: fixed;
      bottom: 0;
      margin-bottom: 0;
    }
  }
}

.product-container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;

  .product {
    width: calc(50% - 10px);
    border: 1px solid $grisclair;
    margin-bottom: 20px;
    flex-direction: row;
  }
}

.order {
  &--detail {
    padding: 20px;
  }
}

.order__btns {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
  height: 75px;
  z-index: 99;

  .order__btn {
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    height: 75px;
    color: white;
    outline: none;
    border-radius: 0;
    padding: 0 20px;

    img {
      width: 25px;
      margin-left: 5px;
      margin-left: 15px;
    }

    span {
      font-size: 11px;
      font-family: 'ClanPro';
      flex: 1;
      text-align: left;
    }

    &.btn--valider {
      background-color: $vert;
      justify-content: space-between;
      align-items: center;
    }

    &.btn--delete {
      background-color: $color1;
      justify-content: space-between;
    }
  }

  .info {
    width: 50%;
    height: 75px;
    line-height: 70px;
    background-color: white;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    text-align: center;
    justify-content: center;

    &__total {
      font-family: 'ClanProBold';
      color: $color1;
      text-transform: uppercase;
      font-size: 12px;
    }

    &__quantity {
      height: 55px;
      width: 55px;
      border-radius: 50%;
      font-family: 'ClanFFBlack';
      font-size: 20px;
      color: $grisfonce;
      border: 1px solid $grisclair;
      text-align: center;
      line-height: 55px;
      margin: 0 10px;
    }

    &__quantity-text {
      color: $grisfonce;
      font-family: 'ClanPro';
      font-size: 12px;
    }
  }
}

@media screen and (max-width: 1320px) {
  .product-container {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderDetail.vue